import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MiniCartModule } from "../mini-cart/mini-cart.module";
import { NewNavbarComponentKub } from "./new-navbar.component";
import { NewNavbarService } from './new-navbar.service';

@NgModule ({
    declarations: [
        NewNavbarComponentKub
    ],
    imports: [
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        MiniCartModule,
        CommonModule
    ],
    exports: [
        NewNavbarComponentKub
    ]
})

export class NewNavbarModuleKub { };